import { Typography as AntdTypography } from 'antd'
import type { TextProps as AntdTextProps } from 'antd/lib/typography/Text'
import { makeBaseTextComponent } from './BaseText'
import type { BaseTextProps } from './BaseText'

export interface TextProps extends AntdTextProps, BaseTextProps {}

export const Text = ({ ...props }: TextProps) => {
  return <AntdTypographyText {...props} />
}

const AntdTypographyText = makeBaseTextComponent(AntdTypography.Text)
